import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";
import Top from "./components/top";
import Bottom from "./components/bottom";
import { Colors } from "utils/colors";
import Modal from "components/modal";
import InsightsFilterReleases from "components/modal/modals/insightsFilterReleases";

const AllRelease = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState({
    releaseTitle: "",
    trackTitle: ""
  });
  return (
    <Container>
      <HeaderFlex>
        <Typography size="2xl" weight="medium">
          All Releases
        </Typography>
        <FilterContainer onClick={() => setFilterOpen(true)}>
          <FilterIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7.91602 11.6665C9.29677 11.6665 10.416 12.7858 10.416 14.1665C10.416 15.5472 9.29677 16.6665 7.91602 16.6665C6.53531 16.6665 5.41602 15.5472 5.41602 14.1665C5.41602 12.7858 6.53531 11.6665 7.91602 11.6665Z"
                stroke="white"
                stroke-width="1.25"
              />
              <path
                d="M12.084 3.3335C10.7032 3.3335 9.58398 4.45278 9.58398 5.8335C9.58398 7.2142 10.7032 8.3335 12.084 8.3335C13.4647 8.3335 14.584 7.2142 14.584 5.8335C14.584 4.45278 13.4647 3.3335 12.084 3.3335Z"
                stroke="white"
                stroke-width="1.25"
              />
              <path
                d="M12.5 14.1318H18.3333"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M7.49935 5.79883H1.66602"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M1.66602 14.1323H3.33268"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M18.3327 5.79883H16.666"
                stroke="white"
                stroke-width="1.25"
                stroke-linecap="round"
              />
            </svg>
          </FilterIcon>
          <Typography color={Colors.white300} weight="medium" ml="0.5">
            Filter
          </Typography>
        </FilterContainer>
      </HeaderFlex>
      <Body>
        <Top />
        <Bottom />
      </Body>
      <Modal isActive={filterOpen} closeModal={() => setFilterOpen(false)}>
        <InsightsFilterReleases
          filterData={filterData}
          setFilterData={(data) => setFilterData(data)}
          active={filterOpen}
          close={() => setFilterOpen(false)}
        />
      </Modal>
    </Container>
  );
};

export default AllRelease;

const Container = styled.section`
  margin-bottom: 3.2rem;
`;

const HeaderFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2.4rem;
`;

const Body = styled.div`
  width: 100%;
  border-radius: 1.6rem;
  overflow: hidden;
`;

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  border-radius: 0.8rem;
  border: 1px solid ${Colors.grey600};
  padding: 0.9rem 0.8rem;
  margin-right: 1.2rem;
  cursor: pointer;
`;

const FilterIcon = styled.div`
  width: 2rem;
  height: 2rem;
`;
